var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable modal-xs",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("activityPrio")) +
                  "\n                "
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col container d-flex flex-column align-items-center"
                  },
                  [
                    _vm.available && _vm.available.length
                      ? [
                          _c(
                            "ul",
                            { staticClass: "row list-group w-100" },
                            _vm._l(_vm.available, function(prio) {
                              return _c(
                                "li",
                                {
                                  key: prio.id,
                                  staticClass: "list-group-item ptr p-1 px-2",
                                  class: {
                                    selected:
                                      prio.id ===
                                      (_vm.selected && _vm.selected.id)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.click(prio)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "div",
                                      { staticStyle: { flex: "1 1 0" } },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(prio.name) +
                                            "\n                                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          "background-color":
                                            "#" + prio.colorTag,
                                          height: "100%",
                                          width: "1rem",
                                          flex: "0 0 1.5rem"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                             \n                                        "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      : [
                          _c("div", { staticClass: "row" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s("(" + _vm.$t("txtEmpty") + ")") +
                                "\n                            "
                            )
                          ])
                        ]
                  ],
                  2
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }